import * as LabelPrimitive from '@radix-ui/react-label';
import { type VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@lib/utils';

const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>;

const Label = (props: LabelProps) => {
  const { className, ...otherProps } = props;

  return (
    <LabelPrimitive.Root
      className={cn(labelVariants(), className)}
      {...otherProps}
    />
  );
};
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
